import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";

export const permission = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '操作',
            key: 'operation',
            scopedSlots: {customRender: 'operation'},
            width: 150
        },
        // {
        //     title: 'ID',
        //     dataIndex: 'id',
        //     key: 'id',
        //     sorter: true,
        //     sortDirections: ["descend", "ascend", "descend"]
        // },
        {
            title: '商务专员名称',
            dataIndex: 'tradeCommissioner.name',
            key: 'tradeCommissioner'
        },
        {
            title: '公司名称',
            key: 'companyname',
            scopedSlots: {
                customRender: 'companyname'
            }
        },
        {
            title: '销售名称',
            key: 'salesManagername',
            scopedSlots: {
                customRender: 'salesManagername'
            }
        },

        {
            title: '创建人',
            dataIndex: 'createBy',
            key: 'createBy',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.createBy || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.name || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },

    ]
}

